import OwlCarouselElementsSliders from "../common/gallery/OwlCarouselElementsSliders";
import DataGalleryFacilityMusicDance from "../common/data/DataGalleryFacilityMusicDance";
const MusicDance = () => {
	return (
	
	<div className="section-full p-t80 p-b50">
		<div className="container">
			<div className="row">
				<div className="col-lg-5 col-md-8 m-b30">
					<div className="about-com-pic">
						<OwlCarouselElementsSliders data={DataGalleryFacilityMusicDance} type={'SlideSlider'}  />
					</div>
				</div>
				<div className="col-lg-7 col-md-12 m-b30">
					<div className="section-head text-left">
						<h3 className="text-uppercase">Music & Dance </h3>
						<div className="wt-separator-outer">
							<div className="wt-separator style-icon">
								<i className="fa fa-leaf text-black"></i>
								<span className="separator-left site-bg-primary"></span>
								<span className="separator-right site-bg-primary"></span>
							</div>                            
						</div>
						<p>Infrastructure serves as the backbone of any institution, an indispensable component that supports and balances all its activities. {process.env.REACT_APP_SITE_TITLE} infrastructure acts as its essential support system, enabling the smooth execution of all its functions.</p>
						<p>Spread across approximately one hectares, HPS’s campus features a well-planned layout that includes the school building, play fields, hostel, swimming pool, and various courts.</p>
						<p>The One-story school building, constructed with exotic stone masonry, boasts over fifty spacious classrooms, well-equipped science labs, an ultra-modern computer lab, an auditorium, an audio-visual room, and a comprehensive library.</p>						
					</div>
					
				</div>
			</div>
		</div>
	</div>   
	
	);
};
export default MusicDance;